import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 d-flex align-items-center" }
const _hoisted_2 = { style: {"letter-spacing":"-1px"} }
const _hoisted_3 = { class: "d-flex flex-column" }

import { computed } from "vue";

import { getColorByStaffId } from "@/lib/utils";
import { IPractitioner } from "@/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'StaffInfoView',
  props: {
    practitioner: {},
    size: { default: 'md' }
  },
  setup(__props: any) {

const props = __props;

const imgStyles = computed(() => {
  let width: string = '2.25rem';
  let fontSize: string = 'var(--font-sm)'

  if (props.size === 'sm') {
    width = '2rem';
    fontSize = 'var(--font-xs)'
  };

  return ({
    width,
    height: width,
    minWidth: width,
    minHeight: width,
    fontSize,
  });
});

const staffNameStyles = computed(() => {
  let fontSize = 'var(--font-base)';

    if (props.size === 'sm') {
    fontSize = 'var(--font-sm)'
  };

  return ({
    fontSize
  });
});

const staffEmailStyles = computed(() => {
  let fontSize = 'var(--font-sm)';

    if (props.size === 'sm') {
    fontSize = 'var(--font-xs)'
  };

  return ({
    fontSize
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "img-wrapper d-flex align-items-center justify-content-center",
      style: _normalizeStyle({
        background: _unref(getColorByStaffId)(__props.practitioner?.id),
        ...imgStyles.value,
      })
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.practitioner?.firstname.charAt(0).toUpperCase()) + " " + _toDisplayString(__props.practitioner?.lastname.charAt(0).toUpperCase()), 1)
    ], 4),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", {
        id: "staff-fullname",
        class: "staff-fullname ellipsis-wrapper",
        style: _normalizeStyle({ ...staffNameStyles.value })
      }, _toDisplayString(__props.practitioner?.firstname + " " + __props.practitioner?.lastname), 5),
      _createElementVNode("span", {
        id: "staff-email",
        class: "staff-email ellipsis-wrapper",
        style: _normalizeStyle({ ...staffEmailStyles.value })
      }, _toDisplayString(__props.practitioner?.email), 5)
    ])
  ]))
}
}

})